import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

@Injectable()
export class ActivationRequestService extends ApiService {
    baseUrl = 'user/send-activate-code';
}
